// removed by extract-text-webpack-plugin
module.exports = {"root":"LoadingButton__root--9__6L","isLoading":"LoadingButton__isLoading--3pn9a","spinner":"LoadingButton__spinner--3aRgb"};


//////////////////
// WEBPACK FOOTER
// ./src/client/src/components/LoadingButton.scss
// module id = 336
// module chunks = 0